import { AuthWelcomeScreen } from 'src/components/auth';

export const AuthWelcomePage = () => {
  return <AuthWelcomeScreen />;
};
